/**
 * IF YOU ARE ADDING/REMOVING SOMETHING HERE
 * REMEBER TO UPDATE IN THE PLAYBOOK-MF-CREATE-PROJECT
 */

export const age = [
  'Any',
];

export const gender = [
  'Any',
  'Male',
  'Female',
  'Non-Binary',
];

export const operatingSystems = {
  ios: 'iOS',
  android: 'Android',
};

export const ethnicity = [
  'Any',
  'American Indian / Alaskan Native',
  'Asian or Pacific Islander',
  'Black or African American',
  'Hispanic or Latino',
  'White / Caucasian',
  'Mixed Ethnicity',
];

export const householdIncome = [
  'Any',
  '<$25,000',
  '$25,001-$50,000',
  '$50,001-$100,000',
  '$100,001-$150,000',
  '$150,001-$200,000',
  '>$200,001',
];

export const workStatus = [
  'Any',
  'Full Time',
  'Part Time',
  'Business Owner',
  'Self-Employed / Contract / Freelance',
  'Unemployed',
  'Retired',
  'Homemaker',
  'Student',
];

export const languages = [
  { text: 'English', value: 'en-US' },
  { text: 'Afrikaans (Afrikaans)', value: 'af-ZA' },
  { text: 'Azərbaycan (Azerbaijani)', value: 'az-AZ' },
  { text: 'Bahasa Indonesia (Indonesian)', value: 'id-ID' },
  { text: 'Català (Catalan)', value: 'ca-ES' },
  { text: 'Čeština (Czech)', value: 'cs-CZ' },
  { text: 'Dansk (Danish)', value: 'da-DK' },
  { text: 'Deutsch (German)', value: 'de-DE' },
  { text: 'Español (Spanish)', value: 'es-ES' },
  { text: 'Français (French)', value: 'fr-FR' },
  { text: 'Hrvatski (Croatian)', value: 'hr-HR' },
  { text: 'Íslenska (Icelandic)', value: 'is-IS' },
  { text: 'Italiano (Italian)', value: 'it-IT' },
  { text: 'Latviešu (Latvian)', value: 'lv-LV' },
  { text: 'Lietuvių (Lithuanian)', value: 'lt-LT' },
  { text: 'Magyar (Hungarian)', value: 'hu-HU' },
  { text: 'Nederlands (Dutch)', value: 'nl-NL' },
  { text: 'Norsk bokmål (Norwegian)', value: 'nb-NO' },
  { text: 'Polski (Polish)', value: 'pl-PL' },
  { text: 'Português (Portuguese - Brazil)', value: 'pt-BR' },
  { text: 'Português (Portuguese - Portugal)', value: 'pt-PT' },
  { text: 'Română (Romanian)', value: 'ro-RO' },
  { text: 'Slovenčina (Slovak)', value: 'sk-SK' },
  { text: 'Slovenščina (Slovenian)', value: 'sl-SI' },
  { text: 'Suomi (Finnish)', value: 'fi-FI' },
  { text: 'Svenska (Swedish)', value: 'sv-SE' },
  { text: 'Swahili (Swahili)', value: 'sw-TZ' },
  { text: 'Tiếng Việt (Vietnamese)', value: 'vi-VN' },
  { text: 'Türkçe (Turkish)', value: 'tr-TR' },
  { text: 'Ελληνικά (Greek)', value: 'el-GR' },
  { text: 'Русский (Russian)', value: 'ru-RU' },
  { text: 'Српски (Serbian)', value: 'sr-RS' },
  { text: 'Українська (Ukrainian)', value: 'uk-UA' },
  { text: 'ქართული (Georgian)', value: 'ka-GE' },
  { text: 'Հայ (Armenian)', value: 'hy-AM' },
  { text: 'हिन्दी (Hindi)', value: 'hi-IN' },
  { text: 'বাংলা (Bengali)', value: 'bn-BD' },
  { text: 'ไทย (Thai)', value: 'th-TH' },
  { text: '한국어 (Korean)', value: 'ko-KR' },
  // { text: '廣東話 (Chinese Cantonese, Traditional)', value: 'yue-Hant-HK' },
  { text: '日本語 (Japanese)', value: 'ja-JP' },
  { text: '普通话 (Chinese Mandarin, Simplified)', value: 'cmn' },
  { text: '(Arabic) عربى', value: 'ar-JO' },
  { text: '(Hebrew) ישראל', value: 'he-IL' },
];

export const industry = [
  'Any',
  'Accounting',
  'Airlines/Aviation',
  'Alternative Dispute Resolution',
  'Alternative Medicine',
  'Animation',
  'Apparel & Fashion',
  'Architecture & Planning',
  'Arts and Crafts',
  'Automotive',
  'Aviation & Aerospace',
  'Banking',
  'Biotechnology',
  'Broadcast Media',
  'Building Materials',
  'Business Supplies and Equipment',
  'Capital Markets',
  'Chemicals',
  'Civic & Social Organization',
  'Civil Engineering',
  'Commercial Real Estate',
  'Computer & Network Security',
  'Computer Games',
  'Computer Hardware',
  'Computer Networking',
  'Computer Software',
  'Construction',
  'Consumer Electronics',
  'Consumer Goods',
  'Consumer Services',
  'Cosmetics',
  'Dairy',
  'Defense & Space',
  'Design',
  'Education Management',
  'E-Learning',
  'Electrical/Electronic Manufacturing',
  'Entertainment',
  'Environmental Services',
  'Events Services',
  'Executive Office',
  'Facilities Services',
  'Farming',
  'Financial Services',
  'Fine Art',
  'Fishery',
  'Food & Beverages',
  'Food Production',
  'Fund-Raising',
  'Furniture',
  'Gambling & Casinos',
  'Glass, Ceramics & Concrete',
  'Government Administration',
  'Government Relations',
  'Graphic Design',
  'Health, Wellness and Fitness',
  'Higher Education',
  'Hospital & Health Care',
  'Hospitality',
  'Human Resources',
  'Import and Export',
  'Individual & Family Services',
  'Industrial Automation',
  'Information Services',
  'Information Technology and Services',
  'Insurance',
  'International Affairs',
  'International Trade and Development',
  'Internet',
  'Investment Banking',
  'Investment Management',
  'Judiciary',
  'Law Enforcement',
  'Law Practice',
  'Legal Services',
  'Legislative Office',
  'Leisure, Travel & Tourism',
  'Libraries',
  'Logistics and Supply Chain',
  'Luxury Goods & Jewelry',
  'Machinery',
  'Management Consulting',
  'Maritime',
  'Market Research',
  'Marketing and Advertising',
  'Mechanical or Industrial Engineering',
  'Media Production',
  'Medical Devices',
  'Medical Practice',
  'Mental Health Care',
  'Military',
  'Mining & Metals',
  'Motion Pictures and Film',
  'Museums and Institutions',
  'Music',
  'Nanotechnology',
  'Newspapers',
  'Non-Profit Organization Management',
  'Oil & Energy',
  'Online Media',
  'Outsourcing/Offshoring',
  'Package/Freight Delivery',
  'Packaging and Containers',
  'Paper & Forest Products',
  'Performing Arts',
  'Pharmaceuticals',
  'Philanthropy',
  'Photography',
  'Plastics',
  'Political Organization',
  'Primary/Secondary Education',
  'Printing',
  'Professional Training & Coaching',
  'Program Development',
  'Public Policy',
  'Public Relations and Communications',
  'Public Safety',
  'Publishing',
  'Railroad Manufacture',
  'Ranching',
  'Real Estate',
  'Recreational Facilities and Services',
  'Religious Institutions',
  'Renewables & Environment',
  'Research',
  'Restaurants',
  'Retail',
  'Security and Investigations',
  'Semiconductors',
  'Shipbuilding',
  'Sporting Goods',
  'Sports',
  'Staffing and Recruiting',
  'Supermarkets',
  'Telecommunications',
  'Textiles',
  'Think Tanks',
  'Tobacco',
  'Translation and Localization',
  'Transportation/Trucking/Railroad',
  'Utilities',
  'Venture Capital & Private Equity',
  'Veterinary',
  'Warehousing',
  'Wholesale',
  'Wine and Spirits',
  'Wireless',
  'Writing and Editing',
];

export const seniority = [
  'Any',
  'Intern',
  'Entry-level',
  'Senior',
  'Manager',
  'Director',
  'Vice President (VP)',
  'Chief X Officer (CxO)',
  'Partner',
  'Owner',
];

export const companySize = [
  'Any',
  'Sole Proprietorship: 1',
  'Small Business: 2-50',
  'Medium Business: 51-1,000',
  'Large Business: 1,001-10,000',
  'Enterprise: 10,001+',
];

export const states = [
  { text: 'Any', value: 'Any' },
  { text: 'Alabama', value: 'AL' },
  { text: 'Alaska', value: 'AK' },
  { text: 'Arizona', value: 'AZ' },
  { text: 'Arkansas', value: 'AR' },
  { text: 'California', value: 'CA' },
  { text: 'Colorado', value: 'CO' },
  { text: 'Connecticut', value: 'CT' },
  { text: 'Delaware', value: 'DE' },
  { text: 'District of Columbia', value: 'DC' },
  { text: 'Florida', value: 'FL' },
  { text: 'Georgia', value: 'GA' },
  { text: 'Hawaii', value: 'HI' },
  { text: 'Idaho', value: 'ID' },
  { text: 'Illinois', value: 'IL' },
  { text: 'Indiana', value: 'IN' },
  { text: 'Iowa', value: 'IA' },
  { text: 'Kansas', value: 'KS' },
  { text: 'Kentucky', value: 'KY' },
  { text: 'Louisiana', value: 'LA' },
  { text: 'Maine', value: 'ME' },
  { text: 'Maryland', value: 'MD' },
  { text: 'Massachusetts', value: 'MA' },
  { text: 'Michigan', value: 'MI' },
  { text: 'Minnesota', value: 'MN' },
  { text: 'Mississippi', value: 'MS' },
  { text: 'Missouri', value: 'MO' },
  { text: 'Montana', value: 'MT' },
  { text: 'Nebraska', value: 'NE' },
  { text: 'Nevada', value: 'NV' },
  { text: 'New Hampshire', value: 'NH' },
  { text: 'New Jersey', value: 'NJ' },
  { text: 'New Mexico', value: 'NM' },
  { text: 'New York', value: 'NY' },
  { text: 'North Carolina', value: 'NC' },
  { text: 'North Dakota', value: 'ND' },
  { text: 'Ohio', value: 'OH' },
  { text: 'Oklahoma', value: 'OK' },
  { text: 'Oregon', value: 'OR' },
  { text: 'Pennsylvania', value: 'PA' },
  { text: 'Rhode Island', value: 'RI' },
  { text: 'South Carolina', value: 'SC' },
  { text: 'South Dakota', value: 'SD' },
  { text: 'Tennessee', value: 'TN' },
  { text: 'Texas', value: 'TX' },
  { text: 'Utah', value: 'UT' },
  { text: 'Vermont', value: 'VT' },
  { text: 'Virginia', value: 'VA' },
  { text: 'Washington', value: 'WA' },
  { text: 'West Virginia', value: 'WV' },
  { text: 'Wisconsin', value: 'WI' },
  { text: 'Wyoming', value: 'WY' },
];

export const screenerMultiple = [
  { text: 'May Select', value: 'May Select' },
  { text: 'Qualify', value: 'Qualify' },
  { text: 'Disqualify', value: 'Disqualify' },
];

export const screenerSingle = [
  { text: 'Qualify', value: 'Qualify' },
  { text: 'Disqualify', value: 'Disqualify' },
];

export const countries = [
  { text: 'Any', value: 'Any' },
  { text: 'United States', value: 'us' },
  { text: 'Canada', value: 'ca' },
  { text: 'United Kingdom', value: 'uk' },
  { text: 'Australia', value: 'au' },
  { text: 'France', value: 'fr' },
  { text: 'Germany', value: 'de' },
  { text: 'India', value: 'in' },
  { text: 'Austria', value: 'at' },
  { text: 'Belgium', value: 'be' },
  { text: 'Brazil', value: 'br' },
  { text: 'Croatia', value: 'hr' },
  { text: 'Czech Republic', value: 'cz' },
  { text: 'Denmark', value: 'dk' },
  { text: 'Finland', value: 'fi' },
  { text: 'Greece', value: 'gr' },
  { text: 'Hungary', value: 'hu' },
  { text: 'Iceland', value: 'is' },
  { text: 'Ireland', value: 'ie' },
  { text: 'Israel', value: 'il' },
  { text: 'Italy', value: 'it' },
  { text: 'Jamaica', value: 'jm' },
  { text: 'Japan', value: 'jp' },
  { text: 'Luxembourg', value: 'lu' },
  { text: 'Mexico', value: 'mx' },
  { text: 'Netherlands', value: 'nl' },
  { text: 'New Zealand', value: 'nz' },
  { text: 'Nigeria', value: 'ng' },
  { text: 'Norway', value: 'no' },
  { text: 'Poland', value: 'pl' },
  { text: 'Portugal', value: 'pt' },
  { text: 'Romania', value: 'ro' },
  { text: 'Serbia', value: 'rs' },
  { text: 'Slovakia', value: 'sk' },
  { text: 'Slovenia', value: 'si' },
  { text: 'South Africa', value: 'za' },
  { text: 'South Korea', value: 'kr' },
  { text: 'Spain', value: 'es' },
  { text: 'Sweden', value: 'se' },
  { text: 'Switzerland', value: 'ch' },
  { text: 'Ukraine', value: 'ua' },
  { text: 'Other countries not listed', value: 'other' },
];

export const remainingCountriesList = [
  { text: 'Austria', value: 'at' },
  { text: 'Belgium', value: 'be' },
  { text: 'Brazil', value: 'br' },
  { text: 'Croatia', value: 'hr' },
  { text: 'Czech Republic', value: 'cz' },
  { text: 'Denmark', value: 'dk' },
  { text: 'Finland', value: 'fi' },
  { text: 'Greece', value: 'gr' },
  { text: 'Hungary', value: 'hu' },
  { text: 'Iceland', value: 'is' },
  { text: 'Ireland', value: 'ie' },
  { text: 'Israel', value: 'il' },
  { text: 'Italy', value: 'it' },
  { text: 'Jamaica', value: 'jm' },
  { text: 'Japan', value: 'jp' },
  { text: 'Luxembourg', value: 'lu' },
  { text: 'Mexico', value: 'mx' },
  { text: 'Netherlands', value: 'nl' },
  { text: 'New Zealand', value: 'nz' },
  { text: 'Nigeria', value: 'ng' },
  { text: 'Norway', value: 'no' },
  { text: 'Poland', value: 'pl' },
  { text: 'Portugal', value: 'pt' },
  { text: 'Romania', value: 'ro' },
  { text: 'Serbia', value: 'rs' },
  { text: 'Slovakia', value: 'sk' },
  { text: 'Slovenia', value: 'si' },
  { text: 'South Africa', value: 'za' },
  { text: 'South Korea', value: 'kr' },
  { text: 'Spain', value: 'es' },
  { text: 'Sweden', value: 'se' },
  { text: 'Switzerland', value: 'ch' },
  { text: 'Ukraine', value: 'ua' },
  { text: 'Other countries not listed', value: 'other' },
];
